import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container } from "semantic-ui-react";
import {
  //HashRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { Auth } from "../firebase/firebase";
import { getRetailers, getUser, hasRole } from "../firebase";
import {
  fetchUser,
  fetchRetailers,
  fetchError,
  openModal,
  closeModal,
} from "../actions";
import ModalManager from "../modals";
import Header from "./header";
import Dashboard from "../banner/dashboard";
import Retailer from "../banner/retailer";
import SkuChecker from "../skus/sku-checker";
import RangeChecker from "../ranging/range-checker";
import Loading from "./loading";
import NotFound from "./404";
import Login from "./login";
import Register from "./register";
import Banner from "../banner/banner";
import Template from "../banner/template";
import { Thankyou } from "./thankyou";
import Admin from "../admin";
import Users from "../admin/users";
import ForgottenPassword from "./forgotten-password";

const App = () => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user);
  const error = useSelector((state) => state.error);

  const [auth, initialising, err] = useAuthState(Auth);

  useEffect(() => {
    if (user) {
      getRetailers(user).then((data) => {
        dispatch(fetchRetailers(data));
      });
    }
    return () => dispatch(fetchRetailers([]));
  }, [dispatch, user]);

  useEffect(() => {
    if (!auth || initialising) {
      dispatch(fetchUser(null));
      dispatch(fetchRetailers([]));
    }
  }, [auth, initialising, dispatch]);

  useEffect(() => {
    if (err) dispatch(fetchError(err));
    return () => dispatch(closeModal());
  }, [err, dispatch]);

  useEffect(() => {
    //Firestore.settings({ experimentalForceLongPolling: true });
    if (auth) {
      //let start = 1;
      //const check = () => {
      //let timer;
      getUser(auth)
        .then((person) => {
          if (person && !auth.emailVerified) {
            dispatch(fetchUser(null));
            dispatch(
              fetchError({
                name: "Email not verified",
                error: "Please check your inbox",
                size: "mini",
              })
            );
            Auth.signOut();
          } else if (!hasRole(person)) {
            dispatch(fetchUser(null));
            dispatch(
              fetchError({
                name: "Access not enabled",
                error:
                  "Please contact an administrator.",
                size: "mini",
              })
            );
            Auth.signOut();
            //} else if (!person && auth) {
            //  if (start === 10) {
            //    dispatch(fetchUser(null));
            //    return Auth.signOut();
            //  }
            //  timer = window.setTimeout(() => {
            //    clearTimeout(timer);
            //    start += 1;
            //    check();
            //  }, 1000);
          } else {
            dispatch(fetchUser(person));
          }
        })
        .catch((error) => {
          //console.log("error", error);
          console.log("app auth", error.message);
          Auth.signOut();
        });
      //    };
      //    check();
    }
  }, [auth, dispatch]);

  useEffect(() => {
    if (error) {
      dispatch(openModal("ErrorModal", { error, centered: false }));
    }
    return () => dispatch(closeModal());
  }, [dispatch, error]);

  if (initialising || (auth && !user)) return <Loading />;

  return (
    <>
      <ModalManager />
      <Header />
      <Container fluid className="wrapper">
        <Routes>
          <Route path="/" exact element={user ? <Dashboard /> : <Login />} />
          <Route
            path="/register"
            element={user ? <Navigate to="/" /> : <Register />}
          />
          <Route
            path="/forgotten-password"
            element={user ? <Navigate to="/" /> : <ForgottenPassword />}
          />
          <Route
            path="/thankyou"
            element={user ? <Navigate to="/" /> : <Thankyou />}
          />
          <Route path="/:retailer/banner/:id/*" element={<Banner />} />
          <Route
            path="/:retailer/new/:template/*"
            element={user ? <Template /> : <Navigate to="/" />}
          />
          <Route
            path="/:retailer/list/:page"
            element={user ? <Retailer /> : <Navigate to="/" />}
          />
          <Route
            path="/:retailer/sku-checker"
            element={user ? <SkuChecker /> : <Navigate to="/" />}
          />
          <Route
            path="/:retailer/range-checker"
            element={user ? <RangeChecker /> : <Navigate to="/" />}
          />
          <Route
            path="/admin/users/:page"
            element={user && user.isAdmin ? <Users /> : <Navigate to="/" />}
          />
          <Route
            path="/admin/retailers"
            element={user && user.isAdmin ? <Admin /> : <Navigate to="/" />}
          />
          <Route element={user ? <NotFound /> : <Navigate to="/" />} />
        </Routes>
      </Container>
    </>
  );
};

export default App;
